import debounce from './debounce/debounce'
import inputDebounce from './debounce/input-debounce'

const install = function (Vue) {
  Vue.directive('debounce', debounce)
  Vue.directive('input-debounce', inputDebounce)
}

if (window.Vue) {
  window['debounce'] = debounce
  window['input-debounce'] = inputDebounce

  Vue.use(install); // eslint-disable-line
}

export default install



// WEBPACK FOOTER //
// ./src/directive/index.js